import { render, staticRenderFns } from "./veStuAssocFundsStandardEdit.vue?vue&type=template&id=3342a295&scoped=true"
import script from "./veStuAssocFundsStandardEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsStandardEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3342a295",
  null
  
)

export default component.exports